(function () {
        function tryPlay(video) {
            if (!video) return;
            var p = video.play();

            if (p && typeof p.then === 'function') {
                p.catch(function () {
                    video.setAttribute('controls', 'controls');
                });
            }
        }

        document.addEventListener('DOMContentLoaded', function () {
            var v = document.querySelector('.mg-mech__video');
            tryPlay(v);
        });
    })();